export interface CountryPrefix {
    code: string;
    name: string;
    prefix: string;
    flag: string;
}

export const COUNTRY_PREFIXES: CountryPrefix[] = [
    { code: 'AF', name: 'Afghanistan', prefix: '93', flag: '🇦🇫' },
    { code: 'AL', name: 'Albania', prefix: '355', flag: '🇦🇱' },
    { code: 'DZ', name: 'Algeria', prefix: '213', flag: '🇩🇿' },
    { code: 'AS', name: 'American Samoa', prefix: '1684', flag: '🇦🇸' },
    { code: 'AD', name: 'Andorra', prefix: '376', flag: '🇦🇩' },
    { code: 'AO', name: 'Angola', prefix: '244', flag: '🇦🇴' },
    { code: 'AI', name: 'Anguilla', prefix: '1264', flag: '🇦🇮' },
    { code: 'AQ', name: 'Antarctica', prefix: '672', flag: '🇦🇶' },
    { code: 'AG', name: 'Antigua and Barbuda', prefix: '1268', flag: '🇦🇬' },
    { code: 'AR', name: 'Argentina', prefix: '54', flag: '🇦🇷' },
    { code: 'AM', name: 'Armenia', prefix: '374', flag: '🇦🇲' },
    { code: 'AW', name: 'Aruba', prefix: '297', flag: '🇦🇼' },
    { code: 'AU', name: 'Australia', prefix: '61', flag: '🇦🇺' },
    { code: 'AT', name: 'Austria', prefix: '43', flag: '🇦🇹' },
    { code: 'AZ', name: 'Azerbaijan', prefix: '994', flag: '🇦🇿' },
    { code: 'BS', name: 'Bahamas', prefix: '1242', flag: '🇧🇸' },
    { code: 'BH', name: 'Bahrain', prefix: '973', flag: '🇧🇭' },
    { code: 'BD', name: 'Bangladesh', prefix: '880', flag: '🇧🇩' },
    { code: 'BB', name: 'Barbados', prefix: '1246', flag: '🇧🇧' },
    { code: 'BY', name: 'Belarus', prefix: '375', flag: '🇧🇾' },
    { code: 'BE', name: 'Belgium', prefix: '32', flag: '🇧🇪' },
    { code: 'BZ', name: 'Belize', prefix: '501', flag: '🇧🇿' },
    { code: 'BJ', name: 'Benin', prefix: '229', flag: '🇧🇯' },
    { code: 'BM', name: 'Bermuda', prefix: '1441', flag: '🇧🇲' },
    { code: 'BT', name: 'Bhutan', prefix: '975', flag: '🇧🇹' },
    { code: 'BO', name: 'Bolivia', prefix: '591', flag: '🇧🇴' },
    { code: 'BA', name: 'Bosnia and Herzegovina', prefix: '387', flag: '🇧🇦' },
    { code: 'BW', name: 'Botswana', prefix: '267', flag: '🇧🇼' },
    { code: 'BR', name: 'Brazil', prefix: '55', flag: '🇧🇷' },
    { code: 'IO', name: 'British Indian Ocean Territory', prefix: '246', flag: '🇮🇴' },
    { code: 'VG', name: 'British Virgin Islands', prefix: '1284', flag: '🇻🇬' },
    { code: 'BN', name: 'Brunei', prefix: '673', flag: '🇧🇳' },
    { code: 'BG', name: 'Bulgaria', prefix: '359', flag: '🇧🇬' },
    { code: 'BF', name: 'Burkina Faso', prefix: '226', flag: '🇧🇫' },
    { code: 'BI', name: 'Burundi', prefix: '257', flag: '🇧🇮' },
    { code: 'KH', name: 'Cambodia', prefix: '855', flag: '🇰🇭' },
    { code: 'CM', name: 'Cameroon', prefix: '237', flag: '🇨🇲' },
    { code: 'CA', name: 'Canada', prefix: '1', flag: '🇨🇦' },
    { code: 'CV', name: 'Cape Verde', prefix: '238', flag: '🇨🇻' },
    { code: 'KY', name: 'Cayman Islands', prefix: '1345', flag: '🇰🇾' },
    { code: 'CF', name: 'Central African Republic', prefix: '236', flag: '🇨🇫' },
    { code: 'TD', name: 'Chad', prefix: '235', flag: '🇹🇩' },
    { code: 'CL', name: 'Chile', prefix: '56', flag: '🇨🇱' },
    { code: 'CN', name: 'China', prefix: '86', flag: '🇨🇳' },
    { code: 'CX', name: 'Christmas Island', prefix: '61', flag: '🇨🇽' },
    { code: 'CC', name: 'Cocos Islands', prefix: '61', flag: '🇰🇨' },
    { code: 'CO', name: 'Colombia', prefix: '57', flag: '🇨🇴' },
    { code: 'KM', name: 'Comoros', prefix: '269', flag: '🇰🇲' },
    { code: 'CK', name: 'Cook Islands', prefix: '682', flag: '🇨🇰' },
    { code: 'CR', name: 'Costa Rica', prefix: '506', flag: '🇨🇷' },
    { code: 'HR', name: 'Croatia', prefix: '385', flag: '🇭🇷' },
    { code: 'CU', name: 'Cuba', prefix: '53', flag: '🇨🇺' },
    { code: 'CU', name: 'Cuba', prefix: '53', flag: '🇨🇺' },
    { code: 'CW', name: 'Curacao', prefix: '599', flag: '🇨🇼' },
    { code: 'CY', name: 'Cyprus', prefix: '357', flag: '🇨🇾' },
    { code: 'CZ', name: 'Czech Republic', prefix: '420', flag: '🇨🇿' },
    { code: 'CD', name: 'Democratic Republic of the Congo', prefix: '243', flag: '🇨🇩' },
    { code: 'DK', name: 'Denmark', prefix: '45', flag: '🇩🇰' },
    { code: 'DJ', name: 'Djibouti', prefix: '253', flag: '🇩🇯' },
    { code: 'DM', name: 'Dominica', prefix: '1767', flag: '🇩🇲' },
    { code: 'DO', name: 'Dominican Republic', prefix: '1809', flag: '🇩🇴' },
    { code: 'TL', name: 'East Timor', prefix: '670', flag: '🇹🇱' },
    { code: 'EC', name: 'Ecuador', prefix: '593', flag: '🇪🇨' },
    { code: 'EG', name: 'Egypt', prefix: '20', flag: '🇪🇬' },
    { code: 'SV', name: 'El Salvador', prefix: '503', flag: '🇸🇻' },
    { code: 'GQ', name: 'Equatorial Guinea', prefix: '240', flag: '🇬🇶' },
    { code: 'ER', name: 'Eritrea', prefix: '291', flag: '🇪🇷' },
    { code: 'EE', name: 'Estonia', prefix: '372', flag: '🇪🇪' },
    { code: 'ET', name: 'Ethiopia', prefix: '251', flag: '🇪🇹' },
    { code: 'FK', name: 'Falkland Islands', prefix: '500', flag: '🇫🇰' },
    { code: 'FO', name: 'Faroe Islands', prefix: '298', flag: '🇫🇴' },
    { code: 'FJ', name: 'Fiji', prefix: '679', flag: '🇫🇯' },
    { code: 'FI', name: 'Finland', prefix: '358', flag: '🇫🇮' },
    { code: 'FR', name: 'France', prefix: '33', flag: '🇫🇷' },
    { code: 'PF', name: 'French Polynesia', prefix: '689', flag: '🇵🇫' },
    { code: 'GA', name: 'Gabon', prefix: '241', flag: '🇬🇦' },
    { code: 'GM', name: 'Gambia', prefix: '220', flag: '🇬🇲' },
    { code: 'GE', name: 'Georgia', prefix: '995', flag: '🇬🇪' },
    { code: 'DE', name: 'Germany', prefix: '49', flag: '🇩🇪' },
    { code: 'GH', name: 'Ghana', prefix: '233', flag: '🇬🇭' },
    { code: 'GI', name: 'Gibraltar', prefix: '350', flag: '🇬🇮' },
    { code: 'GR', name: 'Greece', prefix: '30', flag: '🇬🇷' },
    { code: 'GL', name: 'Greenland', prefix: '299', flag: '🇬🇱' },
    { code: 'GD', name: 'Grenada', prefix: '1473', flag: '🇬🇩' },
    { code: 'GU', name: 'Guam', prefix: '1671', flag: '🇬🇺' },
    { code: 'GT', name: 'Guatemala', prefix: '502', flag: '🇬🇹' },
    { code: 'GG', name: 'Guernsey', prefix: '441481', flag: '🇬🇬' },
    { code: 'GN', name: 'Guinea', prefix: '224', flag: '🇬🇳' },
    { code: 'GW', name: 'GuineaBissau', prefix: '245', flag: '🇬🇼' },
    { code: 'GY', name: 'Guyana', prefix: '592', flag: '🇬🇾' },
    { code: 'HT', name: 'Haiti', prefix: '509', flag: '🇭🇹' },
    { code: 'HN', name: 'Honduras', prefix: '504', flag: '🇭🇳' },
    { code: 'HK', name: 'Hong Kong', prefix: '852', flag: '🇭🇰' },
    { code: 'HU', name: 'Hungary', prefix: '36', flag: '🇭🇺' },
    { code: 'IS', name: 'Iceland', prefix: '354', flag: '🇮🇸' },
    { code: 'IN', name: 'India', prefix: '91', flag: '🇮🇳' },
    { code: 'ID', name: 'Indonesia', prefix: '62', flag: '🇮🇩' },
    { code: 'IR', name: 'Iran', prefix: '98', flag: '🇮🇷' },
    { code: 'IQ', name: 'Iraq', prefix: '964', flag: '🇮🇶' },
    { code: 'IE', name: 'Ireland', prefix: '353', flag: '🇮🇪' },
    { code: 'IM', name: 'Isle of Man', prefix: '441624', flag: '🇮🇲' },
    { code: 'IL', name: 'Israel', prefix: '972', flag: '🇮🇱' },
    { code: 'IT', name: 'Italy', prefix: '39', flag: '🇮🇹' },
    { code: 'CI', name: 'Ivory Coast', prefix: '225', flag: '🇨🇮' },
    { code: 'JM', name: 'Jamaica', prefix: '1876', flag: '🇯🇲' },
    { code: 'JP', name: 'Japan', prefix: '81', flag: '🇯🇵' },
    { code: 'JE', name: 'Jersey', prefix: '441534', flag: '🇯🇪' },
    { code: 'JO', name: 'Jordan', prefix: '962', flag: '🇯🇴' },
    { code: 'KZ', name: 'Kazakhstan', prefix: '7', flag: '🇰🇿' },
    { code: 'KE', name: 'Kenya', prefix: '254', flag: '🇰🇪' },
    { code: 'KI', name: 'Kiribati', prefix: '686', flag: '🇰🇮' },
    { code: 'XK', name: 'Kosovo', prefix: '383', flag: '🇽🇰' },
    { code: 'KW', name: 'Kuwait', prefix: '965', flag: '🇰🇼' },
    { code: 'KG', name: 'Kyrgyzstan', prefix: '996', flag: '🇰🇬' },
    { code: 'LA', name: 'Laos', prefix: '856', flag: '🇱🇦' },
    { code: 'LV', name: 'Latvia', prefix: '371', flag: '🇱🇻' },
    { code: 'LB', name: 'Lebanon', prefix: '961', flag: '🇱🇧' },
    { code: 'LS', name: 'Lesotho', prefix: '266', flag: '🇱🇸' },
    { code: 'LR', name: 'Liberia', prefix: '231', flag: '🇱🇷' },
    { code: 'LY', name: 'Libya', prefix: '218', flag: '🇱🇾' },
    { code: 'LI', name: 'Liechtenstein', prefix: '423', flag: '🇱🇮' },
    { code: 'LT', name: 'Lithuania', prefix: '370', flag: '🇱🇹' },
    { code: 'LU', name: 'Luxembourg', prefix: '352', flag: '🇱🇺' },
    { code: 'MO', name: 'Macao', prefix: '853', flag: '🇲🇴' },
    { code: 'MK', name: 'Macedonia', prefix: '389', flag: '🇲🇰' },
    { code: 'MG', name: 'Madagascar', prefix: '261', flag: '🇲🇬' },
    { code: 'MW', name: 'Malawi', prefix: '265', flag: '🇲🇼' },
    { code: 'MY', name: 'Malaysia', prefix: '60', flag: '🇲🇾' },
    { code: 'MV', name: 'Maldives', prefix: '960', flag: '🇲🇻' },
    { code: 'ML', name: 'Mali', prefix: '223', flag: '🇲🇱' },
    { code: 'MT', name: 'Malta', prefix: '356', flag: '🇲🇹' },
    { code: 'MH', name: 'Marshall Islands', prefix: '692', flag: '🇲🇭' },
    { code: 'MR', name: 'Mauritania', prefix: '222', flag: '🇲🇷' },
    { code: 'MU', name: 'Mauritius', prefix: '230', flag: '🇲🇺' },
    { code: 'YT', name: 'Mayotte', prefix: '262', flag: '🇾🇹' },
    { code: 'MX', name: 'Mexico', prefix: '52', flag: '🇲🇽' },
    { code: 'FM', name: 'Micronesia', prefix: '691', flag: '🇫🇲' },
    { code: 'MD', name: 'Moldova', prefix: '373', flag: '🇲🇩' },
    { code: 'MC', name: 'Monaco', prefix: '377', flag: '🇲🇨' },
    { code: 'MN', name: 'Mongolia', prefix: '976', flag: '🇲🇳' },
    { code: 'ME', name: 'Montenegro', prefix: '382', flag: '🇲🇪' },
    { code: 'MS', name: 'Montserrat', prefix: '1664', flag: '🇲🇸' },
    { code: 'MA', name: 'Morocco', prefix: '212', flag: '🇲🇦' },
    { code: 'MZ', name: 'Mozambique', prefix: '258', flag: '🇲🇿' },
    { code: 'MM', name: 'Myanmar', prefix: '95', flag: '🇲🇲' },
    { code: 'NA', name: 'Namibia', prefix: '264', flag: '🇳🇦' },
    { code: 'NR', name: 'Nauru', prefix: '674', flag: '🇳🇷' },
    { code: 'NP', name: 'Nepal', prefix: '977', flag: '🇳🇵' },
    { code: 'NL', name: 'Netherlands', prefix: '31', flag: '🇳🇱' },
    { code: 'AN', name: 'Netherlands Antilles', prefix: '599', flag: '🇳🇦' },
    { code: 'NC', name: 'New Caledonia', prefix: '687', flag: '🇳🇨' },
    { code: 'NZ', name: 'New Zealand', prefix: '64', flag: '🇳🇿' },
    { code: 'NI', name: 'Nicaragua', prefix: '505', flag: '🇳🇮' },
    { code: 'NE', name: 'Niger', prefix: '227', flag: '🇳🇪' },
    { code: 'NG', name: 'Nigeria', prefix: '234', flag: '🇳🇬' },
    { code: 'NU', name: 'Niue', prefix: '683', flag: '🇳🇺' },
    { code: 'KP', name: 'North Korea', prefix: '850', flag: '🇰🇵' },
    { code: 'MP', name: 'Northern Mariana Islands', prefix: '1670', flag: '🇲🇵' },
    { code: 'NO', name: 'Norway', prefix: '47', flag: '🇳🇴' },
    { code: 'OM', name: 'Oman', prefix: '968', flag: '🇴🇲' },
    { code: 'PK', name: 'Pakistan', prefix: '92', flag: '🇵🇰' },
    { code: 'PW', name: 'Palau', prefix: '680', flag: '🇵🇼' },
    { code: 'PS', name: 'Palestine', prefix: '970', flag: '🇵🇸' },
    { code: 'PA', name: 'Panama', prefix: '507', flag: '🇵🇦' },
    { code: 'PG', name: 'Papua New Guinea', prefix: '675', flag: '🇵🇬' },
    { code: 'PY', name: 'Paraguay', prefix: '595', flag: '🇵🇾' },
    { code: 'PE', name: 'Peru', prefix: '51', flag: '🇵🇪' },
    { code: 'PH', name: 'Philippines', prefix: '63', flag: '🇵🇭' },
    { code: 'PN', name: 'Pitcairn', prefix: '64', flag: '🇵🇳' },
    { code: 'PL', name: 'Poland', prefix: '48', flag: '🇵🇱' },
    { code: 'PT', name: 'Portugal', prefix: '351', flag: '🇵🇹' },
    { code: 'PR', name: 'Puerto Rico', prefix: '1787', flag: '🇵🇷' },
    { code: 'QA', name: 'Qatar', prefix: '974', flag: '🇶🇦' },
    { code: 'CG', name: 'Republic of the Congo', prefix: '242', flag: '🇨🇬' },
    { code: 'RE', name: 'Reunion', prefix: '262', flag: '🇷🇪' },
    { code: 'RO', name: 'Romania', prefix: '40', flag: '🇷🇴' },
    { code: 'RU', name: 'Russia', prefix: '7', flag: '🇷🇺' },
    { code: 'RW', name: 'Rwanda', prefix: '250', flag: '🇷🇼' },
    { code: 'BL', name: 'Saint Barthelemy', prefix: '590', flag: '🇧🇱' },
    { code: 'SH', name: 'Saint Helena', prefix: '290', flag: '🇸🇭' },
    { code: 'KN', name: 'Saint Kitts and Nevis', prefix: '1869', flag: '🇰🇳' },
    { code: 'LC', name: 'Saint Lucia', prefix: '1758', flag: '🇱🇨' },
    { code: 'MF', name: 'Saint Martin', prefix: '590', flag: '🇲🇫' },
    { code: 'PM', name: 'Saint Pierre and Miquelon', prefix: '508', flag: '🇵🇲' },
    { code: 'VC', name: 'Saint Vincent and the Grenadines', prefix: '1784', flag: '🇻🇨' },
    { code: 'WS', name: 'Samoa', prefix: '685', flag: '🇼🇸' },
    { code: 'SM', name: 'San Marino', prefix: '378', flag: '🇸🇲' },
    { code: 'ST', name: 'Sao Tome and Principe', prefix: '239', flag: '🇸🇹' },
    { code: 'SA', name: 'Saudi Arabia', prefix: '966', flag: '🇸🇦' },
    { code: 'SN', name: 'Senegal', prefix: '221', flag: '🇸🇳' },
    { code: 'RS', name: 'Serbia', prefix: '381', flag: '🇷🇸' },
    { code: 'SC', name: 'Seychelles', prefix: '248', flag: '🇸🇨' },
    { code: 'SL', name: 'Sierra Leone', prefix: '232', flag: '🇸🇱' },
    { code: 'SG', name: 'Singapore', prefix: '65', flag: '🇸🇬' },
    { code: 'SX', name: 'Sint Maarten', prefix: '1721', flag: '🇸🇽' },
    { code: 'SK', name: 'Slovakia', prefix: '421', flag: '🇸🇰' },
    { code: 'SI', name: 'Slovenia', prefix: '386', flag: '🇸🇮' },
    { code: 'SB', name: 'Solomon Islands', prefix: '677', flag: '🇸🇧' },
    { code: 'SO', name: 'Somalia', prefix: '252', flag: '🇸🇴' },
    { code: 'ZA', name: 'South Africa', prefix: '27', flag: '🇿🇦' },
    { code: 'KR', name: 'South Korea', prefix: '82', flag: '🇰🇷' },
    { code: 'SS', name: 'South Sudan', prefix: '211', flag: '🇸🇸' },
    { code: 'ES', name: 'Spain', prefix: '34', flag: '🇪🇸' },
    { code: 'LK', name: 'Sri Lanka', prefix: '94', flag: '🇱🇰' },
    { code: 'SD', name: 'Sudan', prefix: '249', flag: '🇸🇩' },
    { code: 'SR', name: 'Suriname', prefix: '597', flag: '🇸🇷' },
    { code: 'SJ', name: 'Svalbard and Jan Mayen', prefix: '47', flag: '🇸🇯' },
    { code: 'SZ', name: 'Swaziland', prefix: '268', flag: '🇸🇿' },
    { code: 'SE', name: 'Sweden', prefix: '46', flag: '🇸🇪' },
    { code: 'CH', name: 'Switzerland', prefix: '41', flag: '🇨🇭' },
    { code: 'SY', name: 'Syria', prefix: '963', flag: '🇸🇾' },
    { code: 'TW', name: 'Taiwan', prefix: '886', flag: '🇹🇼' },
    { code: 'TJ', name: 'Tajikistan', prefix: '992', flag: '🇹🇯' },
    { code: 'TZ', name: 'Tanzania', prefix: '255', flag: '🇹🇿' },
    { code: 'TH', name: 'Thailand', prefix: '66', flag: '🇹🇭' },
    { code: 'TG', name: 'Togo', prefix: '228', flag: '🇹🇬' },
    { code: 'TK', name: 'Tokelau', prefix: '690', flag: '🇹🇰' },
    { code: 'TO', name: 'Tonga', prefix: '676', flag: '🇹🇴' },
    { code: 'TT', name: 'Trinidad and Tobago', prefix: '1868', flag: '🇹🇹' },
    { code: 'TN', name: 'Tunisia', prefix: '216', flag: '🇹🇳' },
    { code: 'TR', name: 'Turkey', prefix: '90', flag: '🇹🇷' },
    { code: 'TM', name: 'Turkmenistan', prefix: '993', flag: '🇹🇲' },
    { code: 'TC', name: 'Turks and Caicos Islands', prefix: '1649', flag: '🇹🇨' },
    { code: 'TV', name: 'Tuvalu', prefix: '688', flag: '🇹🇻' },
    { code: 'VI', name: 'U.S. Virgin Islands', prefix: '1340', flag: '🇻🇮' },
    { code: 'UG', name: 'Uganda', prefix: '256', flag: '🇺🇬' },
    { code: 'UA', name: 'Ukraine', prefix: '380', flag: '🇺🇦' },
    { code: 'AE', name: 'United Arab Emirates', prefix: '971', flag: '🇦🇪' },
    { code: 'GB', name: 'United Kingdom', prefix: '44', flag: '🇬🇧' },
    { code: 'US', name: 'United States', prefix: '1', flag: '🇺🇸' },
    { code: 'UY', name: 'Uruguay', prefix: '598', flag: '🇺🇾' },
    { code: 'UZ', name: 'Uzbekistan', prefix: '998', flag: '🇺🇿' },
    { code: 'VU', name: 'Vanuatu', prefix: '678', flag: '🇻🇺' },
    { code: 'VA', name: 'Vatican', prefix: '379', flag: '🇻🇦' },
    { code: 'VE', name: 'Venezuela', prefix: '58', flag: '🇻🇪' },
    { code: 'VN', name: 'Vietnam', prefix: '84', flag: '🇻🇳' },
    { code: 'WF', name: 'Wallis and Futuna', prefix: '681', flag: '🇼🇫' },
    { code: 'EH', name: 'Western Sahara', prefix: '212', flag: '🇪🇭' },
    { code: 'YE', name: 'Yemen', prefix: '967', flag: '🇾🇪' },
    { code: 'ZM', name: 'Zambia', prefix: '260', flag: '🇿🇲' },
    { code: 'ZW', name: 'Zimbabwe', prefix: '263', flag: '🇿🇼' }
];
